/* import __COLOCATED_TEMPLATE__ from './file-question.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './file-question.module.scss';

const FRONT_SIDE = 'front';
const BACK_SIDE = 'back';

export default class RequestPrescreenerQuestionTypesFileQuestion extends Component {
  @service prescreener;
  @service media;

  styles = styles;

  get isDesktopFeatureEnabled() {
    return !this.media.isXsDown;
  }

  get context() {
    return this.isDesktopFeatureEnabled ? 'forDesktop' : 'forMobile';
  }

  get primaryInstructions() {
    return `booking.prescreener.questions.file.${this.context}.primary`;
  }

  get secondaryInstructions() {
    return `booking.prescreener.questions.file.${this.context}.secondary`;
  }

  get questionName() {
    return this.args.question?.name;
  }

  get clientType() {
    return this.args.clientType;
  }

  get side() {
    return this.args.side;
  }

  get metadataProperties() {
    return {
      questionName: this.questionName,
      clientType: this.clientType,
    };
  }

  get frontFile() {
    return this.getFileFromUploadService(FRONT_SIDE);
  }

  get backFile() {
    return this.getFileFromUploadService(BACK_SIDE);
  }

  @action
  onFileUploadFront(file) {
    this.addFileForUpload(file, FRONT_SIDE);
  }

  @action
  onFileUploadBack(file) {
    this.addFileForUpload(file, BACK_SIDE);
  }

  getFileFromUploadService(side) {
    let fileUpload = this.prescreener.upload.getFile({
      ...this.metadataProperties,
      side,
    });
    return fileUpload?.file;
  }

  addFileForUpload(file, side) {
    this.prescreener.upload.addFileForQuestion({
      ...this.metadataProperties,
      side,
      file,
    });
    this.sendOnChange(file.name);
  }

  sendOnChange(fileName) {
    this.args.onChange?.(this.args.question, !!fileName);
  }
}
